import React, { useState } from 'react';
import { X, Shield } from 'lucide-react';
import { ResponsiveOverlay } from '@/components/ui/ResponsiveOverlay';
import { CompareTable } from '@/components/common/CompareTable';
import { Button } from '@/components/ui/Button';

export function ComparisonModal() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        aria-label="Cost and Privacy Comparison"
        className="flex items-center gap-1.5 text-xs font-medium text-amber-700 bg-amber-100 hover:bg-amber-200 dark:text-amber-400 dark:bg-amber-500/10 dark:hover:bg-amber-500/20 h-8 px-2 sm:px-3 rounded-md border border-amber-200 dark:border-amber-500/20 cursor-pointer"
      >
        <Shield className="w-4 h-4 sm:w-3.5 sm:h-3.5" />
        <span className="hidden sm:inline">Cost & Privacy</span>
      </button>

      <ResponsiveOverlay
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        variant="modal"
        className="w-full sm:max-w-3xl max-h-[90vh] flex flex-col"
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 dark:border-slate-800 shrink-0 bg-slate-50/50 dark:bg-slate-900/50">
          <div className="flex items-center gap-2">
            <div className="bg-amber-100 dark:bg-amber-500/20 p-1.5 rounded-md">
              <Shield className="w-5 h-5 text-amber-600 dark:text-amber-400" />
            </div>
            <h2 className="text-base font-semibold text-slate-900 dark:text-white">Why Use ResumePro?</h2>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsOpen(false)}
            aria-label="Close Comparison Dialog"
            className="rounded-lg text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>

        <div className="overflow-y-auto p-6">
          <CompareTable />
        </div>
        
        <div className="flex justify-end p-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-900/80 shrink-0 sm:rounded-b-2xl">
          <button
            onClick={() => setIsOpen(false)}
            className="w-full sm:w-auto bg-slate-900 hover:bg-slate-800 text-white dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100 font-medium py-2 px-6 rounded-xl text-sm cursor-pointer"
          >
            Got it, thanks
          </button>
        </div>
      </ResponsiveOverlay>
    </>
  );
}

